import { render } from "./InjuryAffirmBill.vue?vue&type=template&id=274b44e2&scoped=true"
import script from "./InjuryAffirmBill.vue?vue&type=script&lang=js"
export * from "./InjuryAffirmBill.vue?vue&type=script&lang=js"

import "./InjuryAffirmBill.vue?vue&type=style&index=0&id=274b44e2&lang=scss&scoped=true"
import "./InjuryAffirmBill.vue?vue&type=style&index=1&id=274b44e2&lang=scss&scoped=true"
import "./InjuryAffirmBill.vue?vue&type=style&index=2&id=274b44e2&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274b44e2"]])

export default __exports__